import React from "react";

export const AdminPageBody = ({children, className = "", contentClassName = ""}) => (
  <main className={`min-h-screen w-full overflow-x-clip bg-[#f5f7fa] md:pl-64 ${className}`}>
    <div className={`mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-6 md:px-8 ${contentClassName}`}>
      {children}
    </div>
  </main>
);

export const AdminLoadingState = () => (
  <div
    className="space-y-4 rounded-lg border border-slate-200 bg-white p-4"
    role="status"
    aria-label="Loading"
  >
    <div className="flex items-center justify-between gap-3">
      <div className="h-4 w-1/3 animate-pulse rounded bg-slate-200/80" />
      <div className="h-9 w-24 animate-pulse rounded-lg bg-slate-200/80" />
    </div>
    <div className="h-3 w-2/3 animate-pulse rounded bg-slate-200/80" />
    <div className="mt-4 space-y-2">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="grid grid-cols-12 items-center gap-3 rounded-lg bg-slate-50 px-3 py-2.5">
          <div className="col-span-5 h-3 animate-pulse rounded bg-slate-200/80" />
          <div className="col-span-3 h-3 animate-pulse rounded bg-slate-200/80" />
          <div className="col-span-2 h-3 animate-pulse rounded bg-slate-200/80" />
          <div className="col-span-2 h-6 animate-pulse rounded-full bg-slate-200/80" />
        </div>
      ))}
    </div>
  </div>
);

export const AdminSectionHeader = ({title, description, count, actions}) => (
  <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div>
        <div className="flex flex-wrap items-center gap-3">
          <h2 className="m-0 text-lg font-semibold tracking-tight text-slate-950">{title}</h2>
          {count !== undefined && (
            <span className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold text-slate-600">
              {count}
            </span>
          )}
        </div>
        {description && <p className="mt-1 mb-0 text-sm text-slate-500">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  </section>
);

export const AdminPanel = ({children, className = ""}) => (
  <section className={`rounded-lg border border-slate-200 bg-white shadow-sm ${className}`}>
    {children}
  </section>
);

export const AdminTablePanel = ({children}) => (
  <AdminPanel className="overflow-visible px-0">
    <div>{children}</div>
  </AdminPanel>
);

export const AdminEmptyState = ({title = "No data to display", description}) => (
  <div className="flex min-h-[220px] flex-col items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white px-6 text-center">
    <h3 className="m-0 text-base font-semibold text-slate-900">{title}</h3>
    {description && <p className="mt-2 mb-0 max-w-md text-sm text-slate-500">{description}</p>}
  </div>
);

export const adminButton =
  "inline-flex min-h-10 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50";

export const adminPrimaryButton =
  "inline-flex min-h-10 items-center justify-center gap-2 rounded-lg border border-[#16213A] bg-[#16213A] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#203052]";

export const adminDangerButton =
  "inline-flex min-h-9 items-center justify-center rounded-lg border border-red-200 bg-red-50 px-3 py-1.5 text-sm font-semibold text-red-700 transition hover:bg-red-100";
